import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@mui/material';
import { deletePlanBundle, listPlans, samplePlan } from './planData';

const MyPlansPage = () => {
  const navigate = useNavigate();
  const [reloadToken, setReloadToken] = useState(0);
  const [planPendingDelete, setPlanPendingDelete] = useState(null);

  const plans = useMemo(() => {
    return listPlans({ includeSample: true });
  }, [reloadToken]);

  const handleDeletePlan = () => {
    if (!planPendingDelete || planPendingDelete.id === samplePlan.id) {
      return;
    }
    deletePlanBundle(planPendingDelete.id);
    setPlanPendingDelete(null);
    setReloadToken((token) => token + 1);
  };

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, maxWidth: 1200, mx: 'auto' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 1.5 }}>
        <Typography variant="h5">My Trial Plans</Typography>
        <Button variant="contained" onClick={() => navigate('/plans/new')}>
          Create Plan
        </Button>
      </Box>

      <Grid container spacing={2}>
        {plans.map((plan) => (
          <Grid item xs={12} md={6} key={plan.id}>
            <Card sx={{ borderRadius: 2.5, border: 1, borderColor: 'divider', boxShadow: 0 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>{plan.name}</Typography>
                <Typography variant="body2" color="text.secondary">Created by: {plan.createdBy}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>Managed by: {plan.managedBy}</Typography>
                <Chip label={plan.approvalStatus} color="primary" variant="outlined" size="small" sx={{ mb: 2 }} />

                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                  <Button size="small" variant="contained" onClick={() => navigate(`/plans/${plan.id}`)}>
                    View
                  </Button>
                  <Button size="small" variant="outlined" onClick={() => navigate(`/plans/${plan.id}/edit`)}>
                    Edit
                  </Button>
                  <Button
                    size="small"
                    color="error"
                    variant="outlined"
                    onClick={() => setPlanPendingDelete(plan)}
                    disabled={plan.id === samplePlan.id}
                  >
                    Delete
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Dialog open={Boolean(planPendingDelete)} onClose={() => setPlanPendingDelete(null)}>
        <DialogTitle>Delete Plan</DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.secondary">
            Are you sure you want to delete {planPendingDelete?.name}? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPlanPendingDelete(null)}>Cancel</Button>
          <Button color="error" variant="contained" onClick={handleDeletePlan}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MyPlansPage;
